<template>
  <div class="dwt_div">
    <span>{{ date }}</span>
    <span>{{ week }}</span>
    <span>{{ time }}</span>
  </div>
</template>

<script>
export default {
  name: "datetime",
  data() {
    return {
      date: '',
      week: '',
      time: '',
      weekArr: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
      timerId: null
    }
  },
  mounted() {
    this.timerId = window.setInterval(this.updateTime, 1000);
  },
  methods: {
    updateTime() {
      let cd = new Date();
      this.time = this.zeroPadding(cd.getHours(), 2) + ':' + this.zeroPadding(cd.getMinutes(), 2) + ':' + this.zeroPadding(cd.getSeconds(), 2);
      this.date = this.zeroPadding(cd.getFullYear(), 4) + '-' + this.zeroPadding(cd.getMonth() + 1, 2) + '-' + this.zeroPadding(cd.getDate(), 2);
      this.week = this.weekArr[cd.getDay()];
    },
    zeroPadding(num, digit) {
      let zero = '';
      for (let i = 0; i < digit; i++) {
        zero += '0';
      }
      return (zero + num).slice(-digit);
    }
  },
  created() {

  },
  //页面销毁清除定时器
  beforeDestroy() {
    if (this.timerId) {
      window.clearInterval(this.timerId);
    }
  },
}
</script>

<style scoped>
.dwt_div {
  color: #00dafc;
  font-size: 1.4rem;
  width: auto;
}

.dwt_div :nth-child(2) {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.dwt_div :nth-child(3) {
  font-size: 1.6rem;
}
</style>